import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccountingtHome from './AccountingHome';
import {
  ACCOUNTING_UNIT_PATH,
  BANK_ACCOUNT_PATH,
  BANK_PATH,
  BILLING_PATH,
  BILLING_REPORT_DETAIL_PATH,
  BILLING_REPORT_RETENTION_PATH,
  BILLING_REPORT_SUMMARY_BY_DOCUMENT_PATH,
  BILLING_REPORT_SUMMARY_PATH,
  DETRACTION_PATH,
  EXCHANGE_RATE_PATH,
  EXPENSE_AUTHORIZER_USER_PATH,
  EXPENSE_SAP_MIGRATION_PATH,
  EXPENSE_TYPE_PATH,
  GENERAL_INCOME_TYPE_PATH,
  LIQUIDATION_DIFFERENCE_REASON_PATH,
  MANUAL_VOUCHER_PATH,
  NEW_BANK_ACCOUNT_PATH,
  NEW_BANK_PATH,
  NEW_BILLING_REPORT_DETAIL_PATH,
  NEW_DETRACTION_PATH,
  NEW_EXCHANGE_RATE_PATH,
  NEW_EXPENSE_AUTHORIZER_USER_PATH,
  NEW_EXPENSE_TYPE_PATH,
  NEW_GENERAL_INCOME_TYPE_PATH,
  NEW_LIQUIDATION_DIFFERENCE_REASON_PATH,
  NEW_MANUAL_VOUCHER_CREDIT_NOTE_PATH,
  NEW_MANUAL_VOUCHER_DEBIT_NOTE_PATH,
  NEW_MANUAL_VOUCHER_PATH,
  NEW_PAYMENT_METHOD_PATH,
  NEW_SALES_TAX_PATH,
  NEW_VOUCHER_TYPE_PATH,
  PAYMENT_METHOD_PATH,
  SALES_TAX_PATH,
  TICKET_TAXABLE_INFORMATION_PATH,
  TRANSACTION_PATH,
  TRIP_EXPENSE_PATH,
  VOUCHER_TYPE_PATH,
} from '../../../config/paths';
import ExpenseTypes from './expense-type/ExpenseTypes';
import ExpenseType from './expense-type/ExpenseType';
import NewExpenseType from './expense-type/NewExpenseType';
import EditExpenseType from './expense-type/EditExpenseType';
import EditTicketTaxableInformation from './ticket-taxable-information/EditTicketTaxableInformation';
import ManualVouchers from './manual-voucher/ManualVouchers';
import NewManualVoucher from './manual-voucher/NewManualVoucher';
import ManualVoucher from './manual-voucher/ManualVoucher';
import EditManualVoucher from './manual-voucher/EditManualVoucher';
import Billings from './billing/Billings';
import Billing from './billing/Billing';
import EditBilling from './billing/EditBilling';
import Detractions from './detraction/Detractions';
import NewDetraction from './detraction/NewDetraction';
import Detraction from './detraction/Detraction';
import EditDetraction from './detraction/EditDetraction';
import NewCreditNoteManualVoucher from './manual-voucher/NewCreditNoteManualVoucher';
import EditCreditNoteManualVoucher from './manual-voucher/EditCreditNoteManualVoucher';
import ExpenseAuthorizerUsers from './expense-authorizer-user/ExpenseAuthorizerUsers';
import NewExpenseAuthorizerUser from './expense-authorizer-user/NewExpenseAuthorizerUser';
import ExpenseAuthorizerUser from './expense-authorizer-user/ExpenseAuthorizerUser';
import EditExpenseAuthorizerUser from './expense-authorizer-user/EditExpenseAuthorizerUser';
import Banks from './bank/Banks';
import NewBank from './bank/NewBank';
import Bank from './bank/Bank';
import EditBank from './bank/EditBank';
import BankAccounts from './bank-account/BankAccounts';
import BankAccount from './bank-account/BankAccount';
import NewBankAccount from './bank-account/NewBankAccount';
import EditBankAccount from './bank-account/EditBankAccount';
import BillReportSummary from './bill-report-summary/BillReportSummary';
import BillReportDetails from './bill-report-detail/BillReportDetails';
import BillReportDetail from './bill-report-detail/BillReportDetail';
import NewBillReportDetail from './bill-report-detail/NewBillReportDetail';
import BillProcessRetentionReversions from './bill-report-retention-reversion/BillProcessRetentionReversions';
import BillReportSummaryByDocument from './bill-report-summary/BillReportSummaryByDocument';
import NewDebitNoteManualVoucher from './manual-voucher/NewDebitNoteManualVoucher';
import TripExpenses from './trip-expense/TripExpenses';
import TripExpense from './trip-expense/TripExpense';
import VoucherTypes from './voucher-type/VoucherTypes';
import VoucherType from './voucher-type/VoucherType';
import NewVoucherType from './voucher-type/NewVoucherType';
import EditVoucherType from './voucher-type/EditVoucherType';
import PaymentMethods from './payment-method/PaymentMethods';
import PaymentMethod from './payment-method/PaymentMethod';
import NewPaymentMethod from './payment-method/NewPaymentMethod';
import EditPaymentMethod from './payment-method/EditPaymentMethod';
import SalesTaxes from './sales-tax/SalesTaxes';
import SalesTax from './sales-tax/SalesTax';
import NewSalesTax from './sales-tax/NewSalesTax';
import EditSalesTax from './sales-tax/EditSalesTax';
import ExchangeRates from './exchange-rate/ExchangeRates';
import ExchangeRate from './exchange-rate/ExchangeRate';
import NewExchangeRate from './exchange-rate/NewExchangeRate';
import EditExchangeRate from './exchange-rate/EditExchangeRate';
import LiquidationDifferenceReason from './liquidation-difference-reason/LiquidationDifferenceReason';
import LiquidationDifferenceReasons from './liquidation-difference-reason/LiquidationDifferenceReasons';
import NewLiquidationDifferenceReason from './liquidation-difference-reason/NewLiquidationDifferenceReason';
import EditLiquidationDifferenceReason from './liquidation-difference-reason/EditLiquidationDifferenceReason';
import GeneralIncomeTypes from './general-income-type/GeneralIncomeTypes';
import GeneralIncomeType from './general-income-type/GeneralIncomeType';
import NewGeneralIncomeType from './general-income-type/NewGeneralIncomeType';
import EditGeneralIncomeType from './general-income-type/EditGeneralIncomeType';
import Transactions from './transaction/Transactions';
import Transaction from './transaction/Transaction';
import ExpenseSapMigrations from './expense-sap-migration/ExpenseSapMigrations';

const AccountingUnit = () => (
  <Switch>
    <Route exact path={ACCOUNTING_UNIT_PATH} component={AccountingtHome} />
    <Route exact path={EXPENSE_TYPE_PATH} component={ExpenseTypes} />
    <Route exact path={NEW_EXPENSE_TYPE_PATH} component={NewExpenseType} />
    <Route exact path={`${EXPENSE_TYPE_PATH}/:id`} component={ExpenseType} />
    <Route
      exact
      path={`${EXPENSE_TYPE_PATH}/:id/edit`}
      component={EditExpenseType}
    />
    <Route
      exact
      path={TICKET_TAXABLE_INFORMATION_PATH}
      component={EditTicketTaxableInformation}
    />
    <Route exact path={MANUAL_VOUCHER_PATH} component={ManualVouchers} />
    <Route exact path={NEW_MANUAL_VOUCHER_PATH} component={NewManualVoucher} />
    <Route
      exact
      path={NEW_MANUAL_VOUCHER_CREDIT_NOTE_PATH}
      component={NewCreditNoteManualVoucher}
    />
    <Route
      exact
      path={`${MANUAL_VOUCHER_PATH}/:id`}
      component={ManualVoucher}
    />
    <Route
      exact
      path={`${MANUAL_VOUCHER_PATH}/:id/edit`}
      component={EditManualVoucher}
    />
    <Route
      exact
      path={`${MANUAL_VOUCHER_PATH}/:id/credit-note/edit`}
      component={EditCreditNoteManualVoucher}
    />
    <Route
      exact
      path={NEW_MANUAL_VOUCHER_DEBIT_NOTE_PATH}
      component={NewDebitNoteManualVoucher}
    />
    <Route
      exact
      path={BILLING_REPORT_SUMMARY_PATH}
      component={BillReportSummary}
    />
    <Route
      exact
      path={BILLING_REPORT_SUMMARY_BY_DOCUMENT_PATH}
      component={BillReportSummaryByDocument}
    />
    <Route
      exact
      path={BILLING_REPORT_DETAIL_PATH}
      component={BillReportDetails}
    />
    <Route
      exact
      path={NEW_BILLING_REPORT_DETAIL_PATH}
      component={NewBillReportDetail}
    />
    <Route
      exact
      path={`${BILLING_REPORT_DETAIL_PATH}/:id`}
      component={BillReportDetail}
    />

    <Route exact path={BILLING_PATH} component={Billings} />
    <Route
      exact
      path={BILLING_REPORT_RETENTION_PATH}
      component={BillProcessRetentionReversions}
    />
    <Route exact path={`${BILLING_PATH}/:id`} component={Billing} />
    <Route exact path={`${BILLING_PATH}/:id/edit`} component={EditBilling} />
    <Route exact path={DETRACTION_PATH} component={Detractions} />
    <Route exact path={NEW_DETRACTION_PATH} component={NewDetraction} />
    <Route exact path={`${DETRACTION_PATH}/:id`} component={Detraction} />
    <Route
      exact
      path={`${DETRACTION_PATH}/:id/edit`}
      component={EditDetraction}
    />
    <Route
      exact
      path={EXPENSE_AUTHORIZER_USER_PATH}
      component={ExpenseAuthorizerUsers}
    />
    <Route
      exact
      path={NEW_EXPENSE_AUTHORIZER_USER_PATH}
      component={NewExpenseAuthorizerUser}
    />
    <Route
      exact
      path={`${EXPENSE_AUTHORIZER_USER_PATH}/:id`}
      component={ExpenseAuthorizerUser}
    />
    <Route
      exact
      path={`${EXPENSE_AUTHORIZER_USER_PATH}/:id/edit`}
      component={EditExpenseAuthorizerUser}
    />
    <Route exact path={TRIP_EXPENSE_PATH} component={TripExpenses} />
    <Route exact path={`${TRIP_EXPENSE_PATH}/:id`} component={TripExpense} />
    <Route exact path={VOUCHER_TYPE_PATH} component={VoucherTypes} />
    <Route exact path={NEW_VOUCHER_TYPE_PATH} component={NewVoucherType} />
    <Route exact path={`${VOUCHER_TYPE_PATH}/:id`} component={VoucherType} />
    <Route
      exact
      path={`${VOUCHER_TYPE_PATH}/:id/edit`}
      component={EditVoucherType}
    />
    <Route exact path={PAYMENT_METHOD_PATH} component={PaymentMethods} />
    <Route exact path={NEW_PAYMENT_METHOD_PATH} component={NewPaymentMethod} />
    <Route
      exact
      path={`${PAYMENT_METHOD_PATH}/:id`}
      component={PaymentMethod}
    />
    <Route
      exact
      path={`${PAYMENT_METHOD_PATH}/:id/edit`}
      component={EditPaymentMethod}
    />
    <Route exact path={SALES_TAX_PATH} component={SalesTaxes} />
    <Route exact path={NEW_SALES_TAX_PATH} component={NewSalesTax} />
    <Route exact path={`${SALES_TAX_PATH}/:id`} component={SalesTax} />
    <Route exact path={`${SALES_TAX_PATH}/:id/edit`} component={EditSalesTax} />
    <Route exact path={EXCHANGE_RATE_PATH} component={ExchangeRates} />
    <Route exact path={NEW_EXCHANGE_RATE_PATH} component={NewExchangeRate} />
    <Route exact path={`${EXCHANGE_RATE_PATH}/:id`} component={ExchangeRate} />
    <Route
      exact
      path={`${EXCHANGE_RATE_PATH}/:id/edit`}
      component={EditExchangeRate}
    />
    <Route
      exact
      path={LIQUIDATION_DIFFERENCE_REASON_PATH}
      component={LiquidationDifferenceReasons}
    />
      <Route
        exact
        path={NEW_LIQUIDATION_DIFFERENCE_REASON_PATH}
        component={NewLiquidationDifferenceReason}
      />
    <Route
      exact
      path={`${LIQUIDATION_DIFFERENCE_REASON_PATH}/:id`}
      component={LiquidationDifferenceReason}
    />
    <Route
      exact
      path={`${LIQUIDATION_DIFFERENCE_REASON_PATH}/:id/edit`}
      component={EditLiquidationDifferenceReason}
    />
    <Route
      exact
      path={GENERAL_INCOME_TYPE_PATH}
      component={GeneralIncomeTypes}
    />
    <Route
      exact
      path={NEW_GENERAL_INCOME_TYPE_PATH}
      component={NewGeneralIncomeType}
    />
    <Route
      exact
      path={`${GENERAL_INCOME_TYPE_PATH}/:id`}
      component={GeneralIncomeType}
    />
    <Route
      exact
      path={`${GENERAL_INCOME_TYPE_PATH}/:id/edit`}
      component={EditGeneralIncomeType}
    />
    <Route
      exact
      path={TRANSACTION_PATH}
      component={Transactions}
    />
    <Route
      exact
      path={`${TRANSACTION_PATH}/:id`}
      component={Transaction}
    />

    <Route exact path={BANK_PATH} component={Banks} />
    <Route exact path={NEW_BANK_PATH} component={NewBank} />
    <Route exact path={`${BANK_PATH}/:id`} component={Bank} />
    <Route exact path={`${BANK_PATH}/:id/edit`} component={EditBank} />
    <Route exact path={BANK_ACCOUNT_PATH} component={BankAccounts} />
    <Route exact path={NEW_BANK_ACCOUNT_PATH} component={NewBankAccount} />
    <Route exact path={`${BANK_ACCOUNT_PATH}/:id`} component={BankAccount} />
    <Route
      exact
      path={`${BANK_ACCOUNT_PATH}/:id/edit`}
      component={EditBankAccount}
    />
    <Route exact path={EXPENSE_SAP_MIGRATION_PATH} component={ExpenseSapMigrations} />
  </Switch>
);

export default AccountingUnit;